<template>
  <div v-if="loaded"
       class="million-read-book-list-detail"
  >
    <div class="million-read-book-list-detail-info ym-border-bottom">
      <div v-if="!inAppWebView"
           class="million-read-book-list-detail-header-bar"
      >
        <ym-header-back-btn class="back-btn" />
        <ym-icon class="share-icon"
                 name="mr-share"
                 v-ym-report:MILLION_VIP_BOOK_LIST_DETAIL_SHARE_CLICK="{
                   title: info.title,
                 }"
                 @click="handleShare"
        />
      </div>
      <ym-img class="bg"
              :src="require('@/assets/img/million_read/book_list_detail_header.png')"
      />
      <div class="container">
        <div class="title">{{ info.title }}</div>
        <div class="summary">{{ info.summary }}</div>
        <div class="bottom">
          <div class="left ym-line-ellipsis">
            <ym-avatar class="avatar"
                       :avatar="info.recommend.avatar"
            />
            <span class="ym-line-ellipsis">{{ info.recommend.desc }}</span>
          </div>
          <div class="right"
               :class="{ 'disabled': isDisabled }"
               v-ym-report:MILLION_VIP_BOOK_LIST_DETAIL_ADD_BOOKSHELF_CLICK="{
                 title: info.title,
               }"
               @click="handleFavoriteAdd"
          >
            <ym-icon v-if="!isDisabled"
                     name="icon_add"
                     class="icon"
            />
            {{ isDisabled ? '已加入书架' : '加入书架' }}·{{ list.length }}
          </div>
        </div>
      </div>
    </div>
    <book-list :list="list" />
    <empty-page v-if="list.length === 0"
                :hint="emptyPageHint"
                type="million-read"
    />
    <share-mask :show.sync="showShareMask"
                :share-path="$wechat.getWechatMenuShareAppLink()"
                message="请复制下方链接，前往粘贴给好友"
    />
  </div>
</template>

<script>
  import { HeaderBackBtn } from '@ymba/ym-ui';
  import ShareMask from '@/components/ShareMask';
  import Avatar from '@/components/Avatar';
  import EmptyPage from '@/components/EmptyPage';
  import BookList from '@/pages/MillionRead/components/BookList';
  import { getBookListDetail, favoriteAdd } from '@/services/million-read';
  import { isAppWebView } from '@/utils';

  export default {
    name: 'MillionReadBookListDetail',
    metaInfo: {},
    components: {
      'ym-header-back-btn': HeaderBackBtn,
      ShareMask,
      BookList,
      EmptyPage,
      'ym-avatar': Avatar,
    },
    data() {
      return {
        showShareMask: false,
        list: [],
        info: {},
        loaded: false,
        notJoined: 0,
      };
    },
    computed: {
      emptyPageHint() {
        return this.loaded ? '书单没有书籍哦~' : '正在加载~';
      },
      isDisabled() {
        return this.notJoined === 0;
      },
      inAppWebView() {
        return isAppWebView();
      },
    },
    methods: {
      handleShare() {
        this.showShareMask = true;
      },
      async fetchData(id) {
        const data = await getBookListDetail({ id });
        this.list = data.list;
        this.info = data.info;
        this.notJoined = data.notJoined;
        this.loaded = true;
      },
      async handleFavoriteAdd() {
        if (this.isDisabled) {
          this.$toast('已加入书架');
          return;
        }
        const idList = this.list.map(item => item.id);
        await favoriteAdd(idList);
        this.notJoined = 0;
      },
    },
    created() {
      const { id } = this.$route.params;
      this.fetchData(id);
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .million-read-book-list-detail {
    min-height: 100%;
    background: @color-white;
    &-header-bar {
      box-sizing: border-box;
      width: 100%;
      height: 88px;
      margin-bottom: 58px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .share-icon {
        font-size: @font-size-extra-large;
      }
    }
    &-info {
      position: relative;
      box-sizing: border-box;
      padding: 0 32px 32px;
      background: linear-gradient(180deg, #fff8ed 0%, #ffffff 100%);
      &:after {
        width: calc(200% - 128px);
        margin: 0 32px;
      }
      .bg {
        position: absolute;
        left: 0;
        top: 88px;
        width: 80px;
        height: 160px;
      }
      .container {
        position: relative;
        z-index: 2;
        .title {
          color: @color-black-dark;
          font-size: @font-size-extra-extra-large;
          font-weight: @font-weight-bold;
          line-height: 1;
          margin-bottom: 33px;
        }
        .summary {
          color: @color-text-light;
          font-size: 30px;
          line-height: 45px;
          margin-bottom: 40px;
        }
        .bottom {
          display: flex;
          justify-content: space-between;
          .left {
            flex: 1;
            display: flex;
            align-items: center;
            padding-right: 10px;
            .avatar {
              flex-shrink: 0;
              width: 40px;
              height: 40px;
              margin-right: 8px;
            }
            span {
              color: @color-text-light;
              font-size: 26px;
            }
          }
          .right {
            flex-shrink: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0 24px;
            height: 70px;
            color: @color-black-dark;
            font-weight: @font-weight-bold;
            border-radius: 18px;
            background: #fed100;
            .icon {
              font-size: @font-size-medium;
              margin-right: 8px;
            }
            &.disabled {
              background: #eee;
            }
          }
        }
      }
    }
    /deep/ .million-read-book-list {
      padding: @size-medium @size-base;
      &-item {
        &:not(:last-child) {
          margin-bottom: @size-extra-medium;
        }
      }
    }
  }

</style>
